import { gql } from '@apollo/client';

export * from './getAssetsCount.query.generated';

export const GET_ASSETS_COUNT = gql`
  query getAssetsCount($softwareEscrowId: ID, $type: AssetTypeEnum) {
    assets(softwareEscrowId: $softwareEscrowId, type: $type) {
      nodesCount
    }
  }
`;
